<template>
  <v-row justify="center" class="my-0">
    <v-dialog v-model="showModal" persistent max-width="470">
      <v-card>
        <v-card-title>
          <div class="title">
            Multiple Account &amp; Bet Limit Rule Acceptance
          </div>
        </v-card-title>
        <v-card-text class="pb-0">
          <p>
            Members are not permitted to hold multiple accounts. This includes
            holding an account with any associated site operating on the same
            platform as this site.
          </p>
          <p>
            Where maximum bet or maximum market limits are imposed, the Site
            reserves to the right to void bets from accounts found to be
            exceeding these limits by using multiple accounts across this and
            any other associated sites.
          </p>
          <p>Please confirm your acceptance and understanding of this rule.</p>
        </v-card-text>

        <v-card-actions class="mx-4">
          <v-checkbox v-model="acceptCheck" small></v-checkbox>
          <v-btn
            :disabled="!acceptCheck"
            color="primary caption lighten-2"
            rounded
            dark
            @click="acceptRules()"
          >
            Accept and Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      acceptCheck: false,
      showModal: true
    }
  },
  computed: {
    ...mapState({
      betRuleData: (state) => state.betRuleAccept.data
    })
  },

  methods: {
    async acceptRules() {
      this.showModal = false
      return
      // eslint-disable-next-line no-unreachable
      await this.$store.dispatch('betRuleAccept/getBetRuleAccept')
      if (this.betRuleData.value) {
        this.showModal = false
        await this.$store.dispatch('user/get')
      } else {
        this.showModal = false
      }
    }
  }
}
</script>
